import { Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from '@/components/theme-provider'
import { Toaster } from '@/components/shadcn/toaster'
import { I18nProvider } from '@/components/i18n-provider'
import { PageTitleProvider } from '@/contexts/PageTitleContext'
import LanguageRedirect from '@/components/LanguageRedirect'
import DashboardLayout from '@/components/layout/DashboardLayout'
import { useDocumentTitle } from '@/hooks/use-document-title'
import SSOCallbackPage from '@/pages/auth/SSOCallbackPage'
import LogoutPage from '@/pages/auth/LogoutPage'
import OverviewPage from '@/pages/dashboard/OverviewPage'
import MemoryPage from '@/pages/dashboard/MemoryPage'
import MemoriesPage from '@/pages/dashboard/MemoriesPage'
import ExportMemoriesPage from '@/pages/dashboard/ExportMemoriesPage'
import ApiKeysPage from '@/pages/dashboard/ApiKeysPage'
import BillingPage from '@/pages/dashboard/BillingPage'
import DocsPage from '@/pages/dashboard/DocsPage'
import MemoryLibrariesPage from '@/pages/dashboard/MemoryLibrariesPage'
import UsageOverviewPage from '@/pages/dashboard/UsageOverviewPage'
import UsageRequestsPage from '@/pages/dashboard/UsageRequestsPage'
import UsagePerformancePage from '@/pages/dashboard/UsagePerformancePage'
import SSOTestPage from '@/pages/SSOTestPage'
import SSODebugPage from '@/pages/SSODebugPage'
import LanguageTestPage from '@/pages/LanguageTestPage'
import SSOProtectedRoute from '@/components/SSOProtectedRoute'

// App内容组件，用于使用标题Hook
function AppContent() {
  // 设置默认标题
  useDocumentTitle();

  return (
    <Routes>
          {/* 根路径语言检测和重定向 */}
          <Route path="/" element={<LanguageRedirect />} />
          
          {/* SSO回调路由 */}
          <Route path="/sso/callback" element={<SSOCallbackPage />} />
          
          {/* SSO测试页面 */}
          <Route path="/sso/test" element={<SSOTestPage />} />
          
          {/* SSO调试页面 */}
          <Route path="/sso/debug" element={<SSODebugPage />} />
          
          {/* 语言检测测试页面 */}
          <Route path="/language-test" element={<LanguageTestPage />} />
          
          {/* 中文路由 */}
          <Route path="/zh">
            {/* 中文根路径重定向到dashboard */}
            <Route index element={<Navigate to="/zh/dashboard" replace />} />
            
            {/* 登出页面 - 不受SSO保护 */}
            <Route path="logout" element={<LogoutPage />} />
            
            <Route
              path="dashboard"
              element={
                <SSOProtectedRoute>
                  <DashboardLayout />
                </SSOProtectedRoute>
              }
            >
              <Route index element={<OverviewPage />} />
              <Route path="memories" element={<MemoryPage />}>
                <Route index element={<MemoryLibrariesPage />} />
                <Route path="detail" element={<MemoriesPage />} />
                <Route path="export" element={<ExportMemoriesPage />} />
              </Route>
              {/* 暂时隐藏操作页面路由 */}
              {/* <Route path="sessions" element={<ManipulationPage />} /> */}
              {/* 暂时隐藏设置页面路由 */}
              {/* <Route path="settings" element={<SettingsPage />} /> */}
              <Route path="billing" element={<BillingPage />} />
              <Route path="docs" element={<DocsPage />} />
              <Route path="usage" element={<UsageOverviewPage />} />
              <Route path="usage/requests" element={<UsageRequestsPage />} />
              <Route path="usage/performance" element={<UsagePerformancePage />} />
              <Route path="*" element={<Navigate to="/zh/dashboard" replace />} />
            </Route>
          </Route>

          {/* 英文路由 */}
          <Route path="/en">
            {/* 英文根路径重定向到dashboard */}
            <Route index element={<Navigate to="/en/dashboard" replace />} />
            
            {/* 登出页面 - 不受SSO保护 */}
            <Route path="logout" element={<LogoutPage />} />
            
            <Route
              path="dashboard"
              element={
                <SSOProtectedRoute>
                  <DashboardLayout />
                </SSOProtectedRoute>
              }
            >
              <Route index element={<OverviewPage />} />
              <Route path="memories" element={<MemoryPage />}>
                <Route index element={<MemoryLibrariesPage />} />
                <Route path="detail" element={<MemoriesPage />} />
                <Route path="export" element={<ExportMemoriesPage />} />
              </Route>
              {/* 暂时隐藏操作页面路由 */}
              {/* <Route path="sessions" element={<ManipulationPage />} /> */}
              {/* 暂时隐藏设置页面路由 */}
              {/* <Route path="settings" element={<SettingsPage />} /> */}
              <Route path="billing" element={<BillingPage />} />
              <Route path="docs" element={<DocsPage />} />
              <Route path="usage" element={<UsageOverviewPage />} />
              <Route path="usage/requests" element={<UsageRequestsPage />} />
              <Route path="usage/performance" element={<UsagePerformancePage />} />
              <Route path="*" element={<Navigate to="/en/dashboard" replace />} />
            </Route>
          </Route>
          
          {/* 其他路径语言检测和重定向 */}
          <Route path="*" element={<LanguageRedirect />} />
        </Routes>
  );
}

function App() {
  return (
    <I18nProvider>
      <ThemeProvider
        defaultTheme="system"
        storageKey="theme"
      >
        <PageTitleProvider>
          <AppContent />
          <Toaster />
        </PageTitleProvider>
      </ThemeProvider>
    </I18nProvider>
  )
}

export default App
